// -------------------------------------------------------------------------------------------------
//-----------------------------------There are two files for template----------------------------
// path1: public-> templates.html
// path2: src-> views-> EmailTemplates-> defaultTemplates.js
//---------------Whenever you change one file, make the change in other file as well-------
//-------------------------------------------------------------------------------------------------
const DefaultTemplate = (body, subject) => {
  const isMobile = window.innerWidth <= 767;
  const safeBody = (typeof body === "string" ? body : "") || "";
  const processedBody = safeBody.replace(
    /<a\s+href="([^"])"[^>]><strong>([^<]*)<\/strong><\/a>/gi,
    `<div style="text-align: start;">
      <a href="$1" style="
        background-color: #8E81F5;
        color: white !important;
        padding: 12px 30px;
        height: 41px;
        border-radius: 60px;
        text-decoration: none;
        font-weight: 600;
        font-family: Inter, sans-serif;
        font-size: 14px;
        text-align: start;
      ">$2</a>
    </div>`,
  );

  return `
  <div style="box-shadow: 2px 2px 204px 0px #00000033; border-radius: 12px; overflow: hidden; background:#ffffff;">
<table 
  width="100%" 
  border="0" 
  cellspacing="0" 
  cellpadding="0" 
  style="font-family:Inter, sans-serif; background:#ffffff;"
>

  <tbody>
      <tr>
          <td valign="top" style="background-color: #f4f2fe;">
              <div style="margin:0; display:block; padding:0; background:#f4f2fe; max-width: 100%; box-shadow: 2px 2px 204px 0px #00000033;">
                  <!-- Header -->
                  <div style="background:#f4f2fe; padding:0;">
                    <div style="margin:0 auto; max-width:540px; background:#f4f2fe; padding:36px 36px 0;">
                      <img src=" https://prodoo.com/assets/images/prodoo-logo.png"
                           alt="Prodoo Logo"
                           style="display: block; margin: 0;max-width: 120px; max-height: 40px; height: auto; width: auto; background-color: #f4f2fe;" />

                      <div style="margin:32px 0 0; text-align:start; font-weight:600; color:#1f2937; display:block; line-height:1.2; height:auto; font-size:${
                        isMobile ? "24px" : "32px"
                      };">
                          <h3 style="display:flex;justify-content:start;margin: 0; text-align:start">${subject ||
                            "Prodoo Email"}</h3>
                      </div>
                    </div>
                  </div>
                  <!-- END Header -->
                  <div style="background:#f4f2fe; color:#4b5563; line-height:136%; font-size:${
                    isMobile ? "14px" : "16px"
                  }; padding:0;">
                    <div style="margin:0 auto; max-width:540px; background:#f4f2fe; padding:0px;">
                      <div style="margin: 0; padding: 0;">
                          ${processedBody}
                      </div>
                      <div>
                          <h5 style="margin: 0; color: #1f2937; font-size: 16px;margin-bottom: 32px;">Thanks, Prodoo team</h5>
                      </div>
                    </div>
                  </div>
              </div>
              <!-- Footer -->
              <div style="background: #8E81F5; width: 100%; color: white;">
                  <div style="margin: 0px; padding: 16px;">
                      <p style="color: white !important;
                                font-family: Inter, sans-serif;
                                font-size: 12px;
                                line-height: 18px;
                                font-weight: 400;
                                text-align: center;
                                margin: 0;">
                          If you have any questions or need assistance, please contact our support team at 
                          <a href="mailto:support@prodoo.com" style="color: white; text-decoration: underline;">support@prodoo.com</a>. 
                          <br />
                          We're here to help!
                      </p>
                  </div>
              </div>
          </td>
      </tr>
  </tbody>
</table>
</div>
  `;
};
export default DefaultTemplate;
